import { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Dumbbell } from "lucide-react";

// UX-POLISH-01 §5 / DEFECT-D-25: a branded loading state (was a bare spinner everywhere) — a
// barbell that tilts like a rep in progress, so a slow network connection still feels "alive"
// instead of stalled. `size`/`label`/`fullPage` cover the two real use-cases: a small inline
// loader inside a card, or a genuine full-VIEWPORT overlay (fixed, dark-scrim, above everything)
// while a shell's data context resolves `/me` — every shell (Owner/Desk/Trainer/Member/Kairoo)
// now uses the exact same `fullPage` overlay instead of some gating on it and some not.
// `delayMs` (default 250ms) means a fast load never flashes it at all — it only mounts if the
// wait genuinely crosses that threshold, so it never feels like unnecessary ceremony.
export function GymLoader({ size = 28, label, fullPage = false, delayMs = 250, testId }) {
  const reducedMotion = useReducedMotion();
  const [show, setShow] = useState(!fullPage);

  useEffect(() => {
    if (!fullPage) return;
    const t = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(t);
  }, [fullPage, delayMs]);

  const content = (
    <div data-testid={testId} className="flex flex-col items-center justify-center gap-3">
      <motion.div
        animate={reducedMotion ? {} : { rotate: [-18, 18, -18] }}
        transition={reducedMotion ? {} : { duration: 1.1, repeat: Infinity, ease: "easeInOut" }}
        style={{ color: "var(--scarlet-accent)" }}
      >
        <Dumbbell size={size} strokeWidth={2.25} />
      </motion.div>
      {label && <p className="text-sm font-medium" style={{ color: "#68686E" }}>{label}</p>}
    </div>
  );

  if (!fullPage) return content;
  if (!show) return null;
  return (
    <motion.div
      initial={reducedMotion ? { opacity: 1 } : { opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: reducedMotion ? 0 : 0.18 }}
      className="fixed inset-0 flex items-center justify-center z-[999] scarlet-canvas"
    >
      {content}
    </motion.div>
  );
}
